import "dotenv/config";
import { CssBaseline, ThemeProvider } from "@mui/material";
import React from "react";
import ReactDOM from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import App from "./App";
import "./index.css";
import theme from "./theme/theme";
import reportWebVitals from "./reportWebVitals";
import ExamesPage from "./routes/page-exames";
import GameConfigPage from "./routes/game-config";
import GamePlayPage from "./routes/game-play";
import GameResultPage from "./routes/game-result";
import Home from "./routes/page-home";
import LivrariasPage from "./routes/page-livrarias";
import LivrosPage from "./routes/page-livros";
import LoginPage from "./routes/page-login";
import RecoverPasswordPage from "./routes/page-recover-password";
import PerguntasPage from "./routes/page-perguntas";
import SchoolsPage from "./routes/page-schools";
import TemasPage from "./routes/page-temas";
import UsersPage from "./routes/page-users";
import UserTemasPage from "./routes/page-user-temas";
import PrivacyAprendeMais from "./routes/privacy-aprendemais";

document.title = "Aprende+";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

const router = createBrowserRouter([
  {
    path: "/",
    element: <GameConfigPage />,
  },
  {
    path: "/jogo",
    element: <GamePlayPage />,
  },
  {
    path: "/jogo/resultado",
    element: <GameResultPage />,
  },
  {
    path: "/login",
    element: <LoginPage />,
  },
  {
    path: "/recuperar-senha",
    element: <RecoverPasswordPage />,
  },
  {
    path: "/aprendemais",
    element: <PrivacyAprendeMais />,
  },
  {
    element: <App />,
    children: [
      {
        path: "/painel",
        element: <Home />,
      },
      {
        path: "/utilizadores",
        element: <UsersPage />,
      },
      {
        path: "/utilizadores/:userId/temas",
        element: <UserTemasPage />,
      },
      {
        path: "/temas",
        element: <TemasPage />,
      },
      {
        path: "/perguntas",
        element: <PerguntasPage />,
      },
      {
        path: "/livrarias",
        element: <LivrariasPage />,
      },
      {
        path: "/livros",
        element: <LivrosPage />,
      },
      {
        path: "/schools",
        element: <SchoolsPage />,
      },
      {
        path: "/exames",
        element: <ExamesPage />,
      },
    ],
  },
]);

root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <RouterProvider router={router} />
    </ThemeProvider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
